import { lazyView } from '../../app/lazyView.js';
import type { ViewComponent } from '../../app/Shell.js';

// Layar kelompok "admin" → komponen (lihat features/PORTING.md). Dimuat terpisah (lazy).
export const views: Record<string, ViewComponent> = {
  beranda: lazyView(() => import('./Beranda.js')),
  keuangan: lazyView(() => import('./Keuangan.js')),
  stok: lazyView(() => import('./Stok.js')),
  laporan: lazyView(() => import('./Laporan.js')),
  biaya: lazyView(() => import('./Biaya.js')),
};
